import React from "react";
import Meta from "./../components/Meta";
import PageHeader from './../components/shell/PageHeader';

function NotFoundPage(props) {
  return (
    <>
      <Meta title="404" />
      <PageHeader back />
      <div className="min-h-screen w-full bg-slate-100 px-6 pb-24 pt-28 text-center">
        The page <code>{props.location.pathname}</code> could not be found
      </div>
    </>
  );
}

export default NotFoundPage;
